module.exports = __webpack_public_path__ + "static/media/lines.aabdd72c.svg";